import React from 'react'
import "../Styles//dokmen-socks.css"

export default function Dokmensocks() {
    return (
        <div className="dokmen-socks">
        <h2>Why are socks so important?</h2>
        <p>
          Yeah, Socks keep your feet warm in winter. We humans have a lot of
          sweat glands in our feet, and all that moisture has to go somewhere…
          better it go into your socks which are easier to wash than your shoes.
          Are you wearing a fresh clean pair of shoes every day? Highly
          unlikely… better to be wearing breathable, light-weight, synthetic,
          merino wool, or silk socks for summer. Don a fresh pair of socks, take
          a big whiff, and walk in confidence knowing you're not the one with
          smelly feet. Also, socks reduce foot abrasion, and they protect feet
          from germs and blisters. Let the socks take the heat, not your feet.
        </p>
      </div>
    )
}
